export const FOLDER_NAME = 'ResyRewards';
export const FILE_NAME = 'ResyRewardsData.json';
